import React from 'react'
import { domainUrl } from '../../constants'
// domain
export const SERVER_API = `${domainUrl}payql`
//export const SERVER_API = 'http://backend.localhost/omniql' //'https://test.geotech.solutions/omniql' //http://test.geotech.solutions/omniql
//'map.omnimaps.io' //localhost:3000
// switch case for ql calls
const qlCalls = async (qlCall, sessionKey, apiKey, object) => {
  let query
  console.log({ qlCall, sessionKey, apiKey, object })

  switch (qlCall) {
    case 'login':
      query = `query{login(username:"${object.username}\",password:\"${object.password}\"){apiKey, message, success,sessionKey}}`
      break
  }

  const getBody = (query, variables) => {
    return {
      OperationName: '',
      Query: query,
      Variables: variables,
    }
  }

  // console.log(JSON.stringify(getBody(query)), 'query')

  return await fetch(SERVER_API, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(getBody(query)),
  })
    .then((response) => response.json())
    .then((data) => {
      // console.log(data, 'post data')
      return data
    })

    .catch((error) => console.log(error))
}

export default qlCalls
